import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translatedRoutes from './id/routes'

export const primaryLanguage = 'en'
export const availableLanguages = ['en', 'id']

const languageInstance = i18n.createInstance()

languageInstance.use(initReactI18next).init({
  lng: primaryLanguage,
  supportedLngs: availableLanguages,
  defaultNS: 'common',
  resources: {
    id: {
      routes: translatedRoutes
    }
  }
})

export default languageInstance
